import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { Structure } from 'app/shared/models/class/structure/structure';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { StructureService } from 'app/shared/services/structure/structure.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-admin-structure-details',
  templateUrl: './admin-structure-details.component.html',
  styleUrls: ['./admin-structure-details.component.scss']
})
export class AdminStructureDetailsComponent extends SubscriptionBaseComponent implements OnInit {

  isUpdate = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['clubCode', 'clubName'];
  displayedColumnsUpdate: string[] = ['clubCode', 'clubName', 'isActive'];
  dataSource: MatTableDataSource<ClubDetails>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  clubs: any = [];

  searchForm: UntypedFormGroup;
  updateStructureForm: UntypedFormGroup;
  valueInput: string;

  structureKey: string;
  structure: Structure;
  showEditStructure: boolean;
  clubSelected: ClubDetails[];
  allClubs: ClubDetails[];
  updateParam: boolean;
  universeSelected = 1;

  constructor(
    private route: ActivatedRoute,
    private structureService: StructureService,
    private formBuilder: UntypedFormBuilder,
    private dataService: DataService,
    private clubService: ClubService,
    private router: Router,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.getStructureById();
  }

  onSubmit(): void {
    const updateStructure = new Structure(this.f.structureName.value, this.clubSelected, this.structure.structureKey);

    this.structureService.updateStructure(updateStructure).subscribe({
      next: () => {
        this.isUpdate = false;
        this.updateParam = false;
        this.getStructureById();
      }
    });
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.valueInput = '';
    this.applyFilter(this.valueInput);
  }

  goEdit(): void {
    this.clubService.getClubDetails().subscribe({
      next: clubs => {
        this.clubs = clubs.sort((a, b) => a.clubCode.localeCompare(b.clubCode));
        this.dataSource = new MatTableDataSource<ClubDetails>(clubs);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.isUpdate = true;
      }
    });
  }

  addOrDeleteCLub(club: ClubDetails): void {
    const indexClub = this.clubSelected.findIndex(cK => cK.clubKey === club.clubKey);

    indexClub !== -1 ?
      this.clubSelected.splice(indexClub, 1) :
      this.clubSelected.push(club);
  }

  clubISelected({ clubKey }): boolean {
    const indexClub = this.clubSelected.findIndex(cK => cK.clubKey === clubKey);
    return indexClub !== -1 ? true : false;
  }

  disabledUpdate(): void {
    this.isUpdate = false;
    this.router.navigate(['/admin/structure']);
    this.getStructureById();
  }

  getUrl(): string {
    return `${environment.urlSite}home?structure=${this.structure?.structureName}&universe=${this.universeSelected}`;
  }

  getEmbedCodeWithSearch(): string {
    return `<iframe src="${environment.urlSite}home?structure=${this.structure?.structureName}&universe=${this.universeSelected}"></iframe>`;
  }

  getEmbedCodeWithOutSearch(): string {
    return `<iframe src="${environment.urlSite}iframe?structure=${this.structure?.structureName}&universe=${this.universeSelected}"></iframe>`;
  }

  copyString(linkCopy: any): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(linkCopy);
    }
  }

  universIsSelected(universe: number): boolean {
    return this.universeSelected === universe ? true : false;
  }

  changeUniverse(universe: number): void {
    this.universeSelected = universe;
  }

  private getStructureById(): void {
    this.structureService.getStructure().subscribe({
      next: structures => {
        this.structure = structures.find(struc => struc.structureKey === +this.structureKey);
        this.clubSelected = this.structure.clubs.sort((a, b) => a.clubCode.localeCompare(b.clubCode));
        this.dataSource = new MatTableDataSource<ClubDetails>(this.structure.clubs);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        this.f.structureName.setValue(this.structure.structureName);
        this.initSub();

        if (this.updateParam) { this.goEdit(); }
      }
    });
  }

  get f() {
    return this.updateStructureForm.controls;
  }

  private initComponent() {
    this.structureKey = this.route.snapshot.queryParams.structureKey;
    this.updateParam = this.route.snapshot.queryParams.update;
    this.isUpdate = this.updateParam ? true : false;

  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });

    this.updateStructureForm = this.formBuilder.group({
      structureName: [''],
      structureKey: [''],
      clubs: ['']
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.showEditStructure.subscribe({
          next: showEditStructure => {
            this.showEditStructure = showEditStructure;
          }
        })
      );
  }

}
